import { Link } from 'react-router-dom';
import { ArrowRight, Flame, Leaf, HandPlatter, Wheat } from 'lucide-react';
import { SITE } from '../data/site';
import { SectionHead, Reveal } from '../components/Bits';
import { Img } from '../components/Img';

const VALUES = [
  { icon: Wheat, t: 'Made fresh daily', d: 'Dough, batters and gravies are prepped every morning — never held over.' },
  { icon: Flame, t: 'Real regional spice', d: 'Chettinad, Dindigul and Kongunad flavors built from whole, roasted spices.' },
  { icon: HandPlatter, t: 'Hand-slapped parottas', d: 'Every parotta is coiled and folded to order for those signature layers.' },
  { icon: Leaf, t: 'Something for everyone', d: 'Deep vegetarian, egg and non-veg menus side by side.' },
];

export default function About() {
  return (
    <div>
      {/* Hero */}
      <section className="relative min-h-[62vh] flex flex-col justify-end overflow-hidden">
        <Img src="https://storage.googleapis.com/happyspace-generated-images/generated/2026-07-09/416db2bf8315.png" alt="Flaky South Indian parotta with spicy chicken curry" eager className="absolute inset-0" imgClassName="scale-105" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(20,13,8,0.55) 0%, rgba(20,13,8,0.2) 38%, rgba(20,13,8,0.9) 100%)' }} />
        <div className="wrap relative pb-14 pt-32 md:pb-20">
          <div className="max-w-2xl">
            <p className="eyebrow" style={{ color: 'var(--color-gold)' }}>Our Story</p>
            <h1 className="font-display mt-3 text-white" style={{ fontSize: 'clamp(2.6rem, 6.5vw, 4.4rem)', lineHeight: 1, textShadow: '0 2px 24px rgba(0,0,0,0.4)' }}>
              A taste of home, brought to Coppell.
            </h1>
            <p className="mt-5" style={{ fontSize: '1.15rem', lineHeight: 1.65, color: 'rgba(255,255,255,0.9)' }}>
              {SITE.tagline}.
            </p>
          </div>
        </div>
      </section>

      {/* Narrative */}
      <section className="wrap py-16 md:py-24">
        <div className="grid gap-12 md:grid-cols-[1.1fr_0.9fr] items-center">
          <Reveal>
            <div className="space-y-5 text-ink-2" style={{ fontSize: '1.1rem', lineHeight: 1.75 }}>
              {SITE.about.map((p) => (
                <p key={p}>{p}</p>
              ))}
            </div>
          </Reveal>
          <Reveal delay={120}>
            <Img src="https://dtwaeonhht2im.cloudfront.net/c1586e6d1af4f2e9910af054b0ef248e-1.jpeg" alt="A crispy dosa served on a banana leaf" className="aspect-square rounded-[var(--pe-radius-lg)]" imgClassName="hover:scale-[1.03]" />
          </Reveal>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 md:py-24" style={{ background: 'var(--color-surface-2)' }}>
        <div className="wrap">
          <SectionHead kicker="What We Stand For" title="Cooked the way it should be" align="center" className="mb-12" />
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map((v, i) => (
              <Reveal as="div" key={v.t} delay={i * 70}>
                <div className="card h-full p-7">
                  <span className="grid place-items-center w-12 h-12 rounded-2xl" style={{ background: 'var(--color-accent-soft)', color: 'var(--color-accent-deep)' }}>
                    <v.icon size={22} />
                  </span>
                  <h3 className="font-display mt-5 text-xl text-ink">{v.t}</h3>
                  <p className="mt-2 text-[0.95rem] text-ink-2 leading-relaxed">{v.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="wrap py-20 md:py-28 text-center">
        <SectionHead kicker="Come Hungry" title="Ready to taste the difference?" align="center" className="mb-8" />
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/menu" className="btn btn-primary">Browse the menu <ArrowRight size={16} /></Link>
          <Link to="/visit" className="btn btn-ghost">Plan your visit</Link>
        </div>
      </section>
    </div>
  );
}
